import { useState } from "react";
import { Get, Set } from "../../../Request";
export const useContactUs = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState({
    btn: false,
  });
  const store = async () => {
    setLoading({ btn: true });
    Set({
      url: "/contactus/store",
      data: form,
    }).then(() => {
      setLoading({ btn: false });
    });
  };
  return { setForm, form, loading, store };
};
